import React, { FC, useEffect }    from "react";
import { useDispatch }             from "react-redux";
import RegisterPlan                from "../../../application/usecase/plan/RegisterPlan";
import MenuType                    from "../../../domain/menu/MenuType";
import Plan                        from "../../../domain/plan/Plan";
import { initPlanAction, usePlan } from "../../../infrastructure/redux/plan/plan";
import BackButton                  from "../../components/button/BackButton";
import SaveButton                  from "../../components/button/SaveButton";
import Breadcrumbs                 from "../../components/common/Breadcrunmbs";
import BottomSection               from "../../components/common/layout/BottomSection";
import TopSection                  from "../../components/common/layout/TopSection";
import BaseLayout                  from "../../components/layout/BaseLayout";
import PlanForm                    from "../../components/plan/PlanForm";

const PlanAddPage: FC = () => {
  const dispatch = useDispatch();
  const plan = usePlan();

  const registerPlan: RegisterPlan = new RegisterPlan(useDispatch());

  useEffect(() => {
    dispatch(initPlanAction(new Plan()));
  }, []);

  return (
    <>
      <BaseLayout
        menuType={ MenuType.PLAN }
        headerTitle="プラン作成"
      >
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "プラン一覧",
                path: "/plans"
              },
              {
                title: "プラン作成",
                path: "/plan/add"
              },
            ]
          }/>
        </TopSection>
        <TopSection>
          <BackButton path="/plans"/>
        </TopSection>
        <TopSection>
          <SaveButton
            onClick={ () => registerPlan.execute(plan) }
            label="保存する"
          />
        </TopSection>

        <PlanForm/>

        <BottomSection>
          <SaveButton
            onClick={ () => registerPlan.execute(plan) }
            label="保存する"
          />
        </BottomSection>
        <BottomSection>
          <BackButton path="/plans"/>
        </BottomSection>
      </BaseLayout>
    </>
  );
};

export default PlanAddPage;
